import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from './__root';
import { requireGuest } from '@/lib/route-guards';

const registerSearchSchema = z.object({
  error: z.string().optional(),
});

export const registerRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/register',
  validateSearch: registerSearchSchema,
  beforeLoad: requireGuest,
  component: lazyRouteComponent(
    () => import('@/features/auth/RegisterPage'),
    'RegisterPage',
  ),
});
